import { render, staticRenderFns } from "./ClientOrganizationStructure.vue?vue&type=template&id=1a522cc3&scoped=true"
import script from "./ClientOrganizationStructure.vue?vue&type=script&lang=js"
export * from "./ClientOrganizationStructure.vue?vue&type=script&lang=js"
import style0 from "./ClientOrganizationStructure.vue?vue&type=style&index=0&id=1a522cc3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a522cc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a522cc3')) {
      api.createRecord('1a522cc3', component.options)
    } else {
      api.reload('1a522cc3', component.options)
    }
    module.hot.accept("./ClientOrganizationStructure.vue?vue&type=template&id=1a522cc3&scoped=true", function () {
      api.rerender('1a522cc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/general/components/ClientOrganizationStructure.vue"
export default component.exports